import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAttachment($companyId: ID!, $attributes: AttachmentAttributes!) {
    createAttachment(companyId: $companyId, attributes: $attributes) {
      attachment {
        id
        ...CreatedAttachment
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAttachment on Blob {
    id
    url
  }
`
